import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaTicketAlt } from 'react-icons/fa';
import toast from 'react-hot-toast';
import { apiFetch } from '../utils/apiFetch';

const OffersPage = () => {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    apiFetch('api/v1/customer/coupons?placement=offers')
      .then((response) => { if (active) setOffers(Array.isArray(response.data) ? response.data : []); })
      .catch((error) => { if (active) toast.error(error.message || 'Could not load offers.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const handleUseOffer = (coupon) => navigate('/cart', { state: { couponCode: coupon.coupon_code } });

  return (
    <main className="min-h-[70vh] bg-gray-50 px-4 py-8 sm:py-12">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 overflow-hidden rounded-3xl bg-gradient-to-r from-[#075b35] to-[#07834b] px-6 py-8 text-white shadow-lg sm:px-10 sm:py-10">
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/15 text-xl"><FaTicketAlt /></span>
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-100">Kisan Daily Fresh</p>
              <h1 className="mt-1 text-2xl font-black sm:text-3xl">Offers made for your basket</h1>
            </div>
          </div>
          <p className="mt-3 max-w-2xl text-sm text-emerald-50">Choose an offer and apply its code in your cart. Final eligibility and savings are confirmed by the server.</p>
        </div>

        {loading ? <div className="rounded-2xl bg-white p-10 text-center text-sm text-gray-500 shadow-sm">Loading offers…</div> : offers.length === 0 ? (
          <div className="rounded-2xl border border-gray-200 bg-white p-10 text-center shadow-sm">
            <FaTicketAlt className="mx-auto text-3xl text-emerald-700" />
            <h2 className="mt-3 text-lg font-bold text-gray-900">No offers available right now</h2>
            <p className="mt-1 text-sm text-gray-500">Please check back soon for new savings.</p>
          </div>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {offers.map((coupon) => (
              <article key={coupon.coupon_id ?? coupon.coupon_code} className="flex flex-col rounded-2xl border border-emerald-100 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="text-xs font-bold uppercase tracking-wider text-emerald-700">{coupon.campaign_type || 'Special offer'}</p>
                    <h2 className="mt-1 text-lg font-extrabold text-gray-900">{coupon.coupon_name || coupon.coupon_code}</h2>
                  </div>
                  <span className="shrink-0 rounded-full bg-emerald-50 px-3 py-1 text-sm font-black text-[#046a38]">
                    {coupon.discount_type === 'percentage' ? `${coupon.discount_value}% OFF` : coupon.discount_type === 'free_delivery' ? 'FREE DELIVERY' : coupon.discount_type === 'buy_x_get_y' ? 'BUY MORE, SAVE MORE' : `₹${coupon.discount_value} OFF`}
                  </span>
                </div>
                <p className="mt-3 flex-1 text-sm leading-6 text-gray-600">{coupon.description || 'Add eligible products to your cart to use this offer.'}</p>
                {coupon.min_order_value > 0 && <p className="mt-3 text-xs text-gray-500">Minimum order: ₹{Number(coupon.min_order_value).toFixed(2)}</p>}
                {coupon.has_no_end_date !== true && coupon.expiry_date && <p className="mt-1 text-xs text-gray-500">Valid until {new Date(coupon.expiry_date).toLocaleDateString('en-IN')}</p>}
                <div className="mt-4 flex items-center justify-between gap-3 border-t border-dashed border-emerald-200 pt-4">
                  <span className="rounded-lg border border-dashed border-emerald-300 bg-emerald-50 px-3 py-2 text-sm font-black tracking-widest text-[#046a38]">{coupon.coupon_code}</span>
                  <button type="button" onClick={() => handleUseOffer(coupon)} className="inline-flex items-center gap-2 rounded-xl bg-[#046a38] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#03572e]">Use offer <FaArrowRight /></button>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </main>
  );
};

export default OffersPage;
